

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETEMPLOYEEEMAILBYCODE= createAsyncThunk(
  "getEmployeeEmailByCode/getEmployeeEmailByCode",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getEmployeeEmailByCodeSlice = createSlice({
  name: "getEmployeeEmailByCodeSlice",
  initialState: {
    getEmployeeEmailByCode: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetEmployeeEmailByCode: (state) => {
        state.getEmployeeEmailByCode.loading = false
        state.getEmployeeEmailByCode.error = false
        state.getEmployeeEmailByCode.data = []
        state.getEmployeeEmailByCode.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETEMPLOYEEEMAILBYCODE.fulfilled, (state, action) => {
      state.getEmployeeEmailByCode = {
        ...state.getEmployeeEmailByCode,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEMPLOYEEEMAILBYCODE.pending, (state, action) => {
      state.getEmployeeEmailByCode = {
        ...state.getEmployeeEmailByCode,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEMPLOYEEEMAILBYCODE.rejected, (state, action) => {
      state.getEmployeeEmailByCode = {
        ...state.getEmployeeEmailByCode,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getEmployeeEmailByCodeAction = {
    GETEMPLOYEEEMAILBYCODE,
};

export { getEmployeeEmailByCodeAction };
export default getEmployeeEmailByCodeSlice.reducer;
export const {setInitialStateOfgetEmployeeEmailByCode} = getEmployeeEmailByCodeSlice.actions
